export default "__VITE_ASSET__CLOluwuP__"